import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '@mui/material';
import useAuth from 'context/useAuth';

import { AppRoutes } from 'routes';

const LogoutButton = () => {
    const { signOut } = useAuth();

    const logOut = () => {
        signOut(AppRoutes.baseRoute);
    };

    return (
        <Button className="logout" disableRipple={true} id="page-header-button-logOut" onClick={logOut}>
            <FormattedMessage id="header.logout" />
        </Button>
    );
};

export default LogoutButton;
